import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

export const muiListOverrides: Components<Theme> = {
  MuiList: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 0,

        "& .MuiListItemIcon-root": {
          minWidth: theme.size?.icon?.medium,
          marginRight: theme.spacing(4),

          "& svg": {
            width: theme.size?.icon?.medium,
            height: theme.size?.icon?.medium,
          },
        },
      }),
      dense: ({ theme }) => ({
        "& .MuiListItemIcon-root": {
          minWidth: theme.size?.icon?.small,
          marginRight: theme.spacing(4),

          "& svg": {
            width: theme.size?.icon?.small,
            height: theme.size?.icon?.small,
          },
        },
      }),
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(6, 0),

        "&.Mui-disabled": {
          opacity: 1,
          color: theme.palette.intent?.disabled.text,
        },
      }),
      dense: ({ theme }) => ({
        padding: theme.spacing(3, 0),
      }),
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(6, 0),
        borderRadius: 0,

        // this is a small adjustment to align with primary text
        ".call-to-action-icon": {
          marginTop: "0.125rem",
        },

        "@media (hover: hover)": {
          "&:hover, &:focus": {
            backgroundColor: "initial",

            ".call-to-action-icon": {
              transform: "scale(1.2)",
            },
          },
        },

        "&.Mui-disabled": {
          opacity: 1,
          color: theme.palette.intent?.disabled.text,

          "& .MuiTypography-root": {
            color: `${String(theme.palette.intent?.disabled.text)} !important`,
          },
        },
      }),
      dense: ({ theme }) => ({
        ".call-to-action-icon": {
          marginTop: 0,
        },

        padding: theme.spacing(3, 0),
      }),
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: "inherit",
        alignSelf: "flex-start",

        "&.Mui-disabled": {
          color: theme.palette.intent?.disabled.icon,
        },
      }),
    },
  },
  MuiListItemText: {
    styleOverrides: {
      root: ({ theme }) => ({
        margin: 0,

        "& .MuiListItemText-primary": {
          color: theme.palette.text.primary,
          fontSize: theme.typography.h6.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          letterSpacing: theme.typography.h6.letterSpacing,
          lineHeight: theme.typography.h6.lineHeight,
        },

        "& .MuiListItemText-secondary": {
          marginTop: theme.spacing(1),
          color: theme.palette.text.primary,
          fontSize: theme.typography.body2.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          letterSpacing: theme.typography.body2.letterSpacing,
          lineHeight: theme.typography.body2.lineHeight,
        },

        // Dense is not a property on MuiListItemText, but this class is passed down when dense is true on parent item
        "&.MuiListItemText-dense": {
          "& .MuiListItemText-primary": {
            fontSize: theme.typography.body1.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
            letterSpacing: theme.typography.body1.letterSpacing,
            lineHeight: theme.typography.body1.lineHeight,
          },

          "& .MuiListItemText-secondary": {
            color: theme.palette.intent?.disabled.text,
          },
        },
      }),
    },
  },
};
